import { authRouter } from './routes/auth'
import { userRouter } from './routes/user'
import { tenantRouter } from './routes/tenant'
import { supportRouter } from './routes/support'
import { homeRouter } from './routes/home'
import { stageRouter } from './routes/stage'
import { typeRouter } from './routes/type'
import { ratingFrameworkRouter } from './routes/ratingFramework'
import { locationRouter } from './routes/location'
import { superAdminRouter } from './routes/superAdmin'
import { projectRouter } from './routes/project'
import { layerRouter } from './routes/layer'
import { memberRouter } from './routes/members'
import { mapboxRouter } from './routes/mapbox'
import { datasetRouter } from './routes/dataset'
import { oauthRouter } from './routes/oauth'

export const api = {
  auth: authRouter,
  user: userRouter,
  tenant: tenantRouter,
  support: supportRouter,
  home: homeRouter,
  stage: stageRouter,
  type: typeRouter,
  ratingFramework: ratingFrameworkRouter,
  location: locationRouter,
  superAdmin: superAdminRouter,
  project: projectRouter,
  layer: layerRouter,
  member: memberRouter,
  mapbox: mapboxRouter,
  dataset: datasetRouter,
  oauth: oauthRouter,
}
